/**
 * Une demande de rappel issue du questionnaire de départ.
 *
 * Ce n'est pas encore un client : c'est une fiche que le coach lit avant
 * de décrocher son téléphone. Le compte, lui, sera créé après l'appel —
 * pas ici, pour ne jamais avoir à demander un mot de passe.
 */
export type Lead = {
  objectif: string
  depart: string
  rythme: string
  creneaux: string[]
  prenom: string
  nom: string
  telephone: string
  codePostal: string
  /** Champ libre, facultatif. Voir la note sur les données de santé ci-dessous. */
  aSavoir: string
}

/**
 * Envoi de la fiche.
 *
 * TODO — brancher sur Supabase (table `leads`, insertion via une Server
 * Action pour que la clé ne parte pas au navigateur).
 *
 * Note données de santé : `aSavoir` est un champ libre où un prospect peut
 * écrire une blessure ou une opération. C'est une donnée de santé au sens du
 * RGPD. Elle doit rester visible du seul coach, ne pas être recopiée
 * ailleurs, et être effacée si la personne ne devient pas cliente. Ne pas
 * transformer ce champ en liste de pathologies à cocher : on collecterait
 * beaucoup plus, pour un service qui n'en a pas besoin.
 */
export async function submitLead(lead: Lead): Promise<void> {
  // Simulation le temps que la base existe : laisse voir l'état de chargement.
  await new Promise((resolve) => setTimeout(resolve, 700))
  console.info("[lead]", lead)
}
